// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import AccountComponent from 'Components/Account/Account';

const StyledAccountPage = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const AccountPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let accountPageClassNames = bodyAttributes?.class || '';
  if (!accountPageClassNames.includes('AccountPage')) {
    accountPageClassNames += 'AccountPage';
  }

  return (
    <>
      <Helmet>
        <body className={ accountPageClassNames } />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.account') }</title>
      </Helmet>
      <StyledAccountPage theme={ theme } className="grid-container">
        <AccountSideMenu />
        <AccountComponent />
      </StyledAccountPage>
    </>
  );
});

AccountPage.displayName = 'AccountPage';

export default AccountPage;
